import { createApp } from 'vue'
import App from './App.vue';
import '@/styles/main.scss';
import 'aos/dist/aos.css';

createApp(App).mount('#app')